export enum ContractType {
  Bectu_TV = 'Bectu_TV',
  Bectu_MMP = 'Bectu_MMP',
  SVOD = 'SVOD',
}

export const ContractTypes = Object.values(ContractType);
